import { render, staticRenderFns } from "./DatatablePagination.vue?vue&type=template&id=3a65e6de&"
import script from "./DatatablePagination.vue?vue&type=script&lang=js&"
export * from "./DatatablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports